import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchInventoryStockCheckList = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)
    if(payload.store_list.length === 0) {
        return false
    } else {
        axios.post('/inventoryStockCheck/index.php', payload, accessTokenInfo.accessTokenInfo())
        .then(res => {

            if(res.data.try_again) {
                dispatch('fetchInventoryStockCheckList', payload)
            } else {
                commit('setInventoryStockCheckList', {response: res.data.response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number})
            }
        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error'})
        })
        .finally( () => {
            commit('toggleLoadingState', false)
        })
    }
}

export const fetchInventoryStockCheckData = ({commit}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/inventoryStockCheck/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        if(res.data.status) {
            
            commit('setInventoryStockCheckData', {response: res.data.response, copy: payload.copy})   
            
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }

        } else {
            commit('resetInventoryStockCheckData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitInventoryStockCheckData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/inventoryStockCheck/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {     
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            dispatch('fetchInventoryStockCheckData', {id: res.data.id})
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteInventoryStockCheckData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/inventoryStockCheck/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchInventoryStockCheckList', payload.list)
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryStockCheck/actions.js